const CAMERA_MODE = {
  NoControls: 'NO_CONTROLS',
  Focused: 'FOCUSED',
  OrbitControls: 'ORBIT_CONTROLS',
  Static: 'STATIC',
}

const CAMERA_FOCUS_OBJECT_TYPE = {
  Room: 'ROOM',
  LastPosition: 'LAST_POSITION',
  Monitor: 'MONITOR',
  Keyboard: 'KEYBOARD',
}

const FOCUS_TYPE = {
  Object: 'OBJECT',
  Position: 'POSITION',
}

export { CAMERA_FOCUS_OBJECT_TYPE, FOCUS_TYPE, CAMERA_MODE };
